"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let MailAccountConfig = class MailAccountConfig extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getBcc(...args) {
        return _.split(this.bcc, '\n').map(_.trim).filter(Boolean);
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    recipient;
    async $$load_recipient() {
        return this.$app.auth.user.email;
    }
    sendMailTestResult;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    sendTestEmailFormId;
    async $$load_sendTestEmailFormId() {
        return this.$fn.randomElementId();
    }
    formName;
    sendTestEmailFormName;
    config;
    resource;
    async $$load_resource() {
        return this.oid
            ? this.$fn.fetch('get_object_by_type', { parameters: { id: this.oid, object_type: 'mail-account' }, asResource: true })
            : new this.$fn.Resource(_.reduce(this.$data.config, (m, v, k) => _.set(m, k, _.get(v, 'default', null))));
    }
    editor;
    async $$load_editor() {
        return this.resource.editor();
    }
    change_password;
    bcc;
    async $$load_bcc() {
        return _.join(this.$data.resource.bcc, '\n');
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['recipient', 'sendMailTestResult', 'formId', 'sendTestEmailFormId', 'formName', 'sendTestEmailFormName', 'config', 'resource', 'editor', 'change_password', 'bcc', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                recipient: null,
                sendMailTestResult: null,
                formId: null,
                sendTestEmailFormId: null,
                formName: "MailAccountConfig",
                sendTestEmailFormName: "SendTestEmail",
                config: {
                    tls: {
                        label: this.$fn.pgettext("MailAccount", "Use TLS"),
                        help: this.$fn.pgettext("MailAccount", "Enable TLS encryption for the connection."),
                        default: true,
                    },
                    ssl: {
                        label: this.$fn.pgettext("MailAccount", "SSL"),
                        help: this.$fn.pgettext("MailAccount", "Use SSL to secure the connection."),
                        default: true,
                    },
                    use_credentials: {
                        label: this.$fn.pgettext("MailAccount", "Use Credentials"),
                        help: this.$fn.pgettext("MailAccount", "Require username and password to authenticate."),
                        default: true,
                    },
                    validate_certs: {
                        label: this.$fn.pgettext("MailAccount", "Validate Certificates"),
                        help: this.$fn.pgettext("MailAccount", "Check that server certificates are valid."),
                        default: true,
                    },
                    mail_from_name: {
                        label: this.$fn.pgettext("MailAccount", "Mail From Name"),
                        help: this.$fn.pgettext("MailAccount", "Name displayed as the sender of the email."),
                    },
                    server: {
                        label: this.$fn.pgettext("MailAccount", "Server"),
                        help: this.$fn.pgettext("MailAccount", "Address of the mail server."),
                        default: "smtp.server.com",
                    },
                    port: {
                        label: this.$fn.pgettext("MailAccount", "Port"),
                        help: this.$fn.pgettext("MailAccount", "Port number for the mail server connection."),
                        default: 587,
                    },
                    debug: {
                        label: this.$fn.pgettext("MailAccount", "Debug"),
                        help: this.$fn.pgettext("MailAccount", "Show detailed connection and sending logs."),
                        default: false,
                    },
                    username: {
                        label: this.$fn.pgettext("MailAccount", "Username"),
                        help: this.$fn.pgettext("MailAccount", "Your login name for authentication."),
                    },
                    password: {
                        label: this.$fn.pgettext("MailAccount", "Password"),
                        help: this.$fn.pgettext("MailAccount", "Your account password."),
                    },
                    confirm_password: {
                        label: this.$fn.pgettext("MailAccount", "Confirm Password"),
                        help: this.$fn.pgettext("MailAccount", "Re-enter password to verify."),
                    },
                    timeout: {
                        label: this.$fn.pgettext("MailAccount", "Timeout"),
                        help: this.$fn.pgettext("MailAccount", "Time to wait before giving up."),
                        default: 60,
                    },
                    description: {
                        label: this.$fn.pgettext("MailAccount", "Description"),
                        help: this.$fn.pgettext("MailAccount", "Short note or label for this entry."),
                    },
                    address: {
                        label: this.$fn.pgettext("MailAccount", "Address"),
                        help: this.$fn.pgettext("MailAccount", "Email or server address to use."),
                        default: "username@provider.com",
                    },
                    bcc: {
                        label: this.$fn.pgettext("MailAccount", "Bcc"),
                        help: this.$fn.pgettext("MailAccount", "The Blind Carbon Copy to use when sending emails."),
                        default: [],
                    },
                },
                resource: null,
                editor: null,
                change_password: {
                    password: null,
                    confirm_password: null,
                },
                bcc: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.$fn.pgettext("MailAccountConfig|Title", "Mail account configuration"),
                ],
                icon: this.$config.settings.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4560_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_4566_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_4564_getActionArgs($event) {
        return {
            objectType: "object_by_type",
            op: "upsert",
            data: {
                ...this.editor.getData(),
                'object_type': 'mail-account',
                ...(this.change_password.password && this.change_password.confirm_password ? this.change_password : {}),
                bcc: this.getBcc()
            },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_4186377094414664_closeModal_4570_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_4186377094414664_crud_4568_getActionArgs($event) {
        return {
            objectType: "object_by_type",
            op: "upsert",
            data: {
                ...this.editor.getData(),
                'object_type': 'mail-account',
                ...(this.change_password.password && this.change_password.confirm_password ? this.change_password : {}),
                bcc: this.getBcc()
            },
        };
    }
    async evh_4186377094414664_submit(event, scope) {
        return await this.actions.evh_4186377094414664_submit.executeFromDOM(this, event, scope);
    }
    async act_4699325371235600_setData_4572_getActionArgs($event) {
        return {
            path: "sendMailTestResult",
            value: null,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_4699325371235600_script_4576_getActionArgs_value($event) {
        this.sendMailTestResult = 'success';
    }
    async act_4699325371235600_script_4576_getActionArgs($event) {
        return {
            value: () => this.act_4699325371235600_script_4576_getActionArgs_value($event),
        };
    }
    async act_4699325371235600_request_4574_getActionArgs($event) {
        return {
            operation: "post_sendmail_test",
            data: { mail_account: this.resource.id, recipient: this.recipient },
        };
    }
    async evh_4699325371235600_clickPreventStop(event, scope) {
        return await this.actions.evh_4699325371235600_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_closeModal_4580_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1548630417156826_request_4578_getActionArgs($event) {
        return {
            operation: "delete_object_by_type",
            data: this.resource.getData({ fields: ['id', 'etag'] }),
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_2186679009640457_closeModal_4582_getActionArgs($event) {
        return {
            name: this.modalName,
        };
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4560 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4560_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4559 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4560,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4559],
        });
        const act_2248226175642056_closeComponent_4562 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_4561 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_4562,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_4561],
        });
        const act_1040167445267876_closeModal_4566 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_4566_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_4565 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_4566,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_crud_4564 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_4564_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_4565],
        });
        const evh_1040167445267876_submit_4563 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_4564,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_4563],
        });
        const act_4186377094414664_closeModal_4570 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_4186377094414664_closeModal_4570_getActionArgs,
            events: [],
        });
        const evh_4186377094414664_success_4569 = new core_1.actions.EventHandlerImpl({
            action: act_4186377094414664_closeModal_4570,
            event: "success",
            displayName: "closeModal",
        });
        const act_4186377094414664_crud_4568 = new core_1.actions.CRUDAction({
            actionArgs: this.act_4186377094414664_crud_4568_getActionArgs,
            displayName: "save",
            events: [evh_4186377094414664_success_4569],
        });
        const evh_4186377094414664_submit_4567 = new core_1.actions.EventHandlerImpl({
            action: act_4186377094414664_crud_4568,
            event: "submit",
            displayName: "save",
        });
        const evh_4186377094414664_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4186377094414664_submit_4567],
        });
        const act_4699325371235600_setData_4572 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4699325371235600_setData_4572_getActionArgs,
            events: [],
        });
        const evh_4699325371235600_clickPreventStop_4571 = new core_1.actions.EventHandlerImpl({
            action: act_4699325371235600_setData_4572,
            event: "click.prevent.stop",
            displayName: "setData",
        });
        const act_4699325371235600_script_4576 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4699325371235600_script_4576_getActionArgs,
            events: [],
        });
        const evh_4699325371235600_success_4575 = new core_1.actions.EventHandlerImpl({
            action: act_4699325371235600_script_4576,
            event: "success",
            displayName: "script",
        });
        const act_4699325371235600_request_4574 = new core_1.actions.RequestAction({
            actionArgs: this.act_4699325371235600_request_4574_getActionArgs,
            displayName: "sendTestEmail",
            events: [evh_4699325371235600_success_4575],
        });
        const evh_4699325371235600_clickPreventStop_4573 = new core_1.actions.EventHandlerImpl({
            action: act_4699325371235600_request_4574,
            event: "click.prevent.stop",
            displayName: "sendTestEmail",
        });
        const evh_4699325371235600_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4699325371235600_clickPreventStop_4571, evh_4699325371235600_clickPreventStop_4573],
        });
        const act_1548630417156826_closeModal_4580 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1548630417156826_closeModal_4580_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_4579 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeModal_4580,
            event: "success",
            displayName: "closeModal",
        });
        const act_1548630417156826_request_4578 = new core_1.actions.RequestAction({
            actionArgs: this.act_1548630417156826_request_4578_getActionArgs,
            displayName: "delete",
            events: [evh_1548630417156826_success_4579],
        });
        const evh_1548630417156826_clickPreventStop_4577 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_request_4578,
            event: "click.prevent.stop",
            displayName: "delete",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_4577],
        });
        const act_2186679009640457_closeModal_4582 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2186679009640457_closeModal_4582_getActionArgs,
            events: [],
        });
        const evh_2186679009640457_clickPreventStop_4581 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeModal_4582,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_4581],
        });
        return {
            act_7315092382398562_closeModal_4560,
            evh_7315092382398562_close_4559,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_4562,
            evh_2248226175642056_close_4561,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_4566,
            evh_1040167445267876_success_4565,
            act_1040167445267876_crud_4564,
            evh_1040167445267876_submit_4563,
            evh_1040167445267876_submit,
            act_4186377094414664_closeModal_4570,
            evh_4186377094414664_success_4569,
            act_4186377094414664_crud_4568,
            evh_4186377094414664_submit_4567,
            evh_4186377094414664_submit,
            act_4699325371235600_setData_4572,
            evh_4699325371235600_clickPreventStop_4571,
            act_4699325371235600_script_4576,
            evh_4699325371235600_success_4575,
            act_4699325371235600_request_4574,
            evh_4699325371235600_clickPreventStop_4573,
            evh_4699325371235600_clickPreventStop,
            act_1548630417156826_closeModal_4580,
            evh_1548630417156826_success_4579,
            act_1548630417156826_request_4578,
            evh_1548630417156826_clickPreventStop_4577,
            evh_1548630417156826_clickPreventStop,
            act_2186679009640457_closeModal_4582,
            evh_2186679009640457_clickPreventStop_4581,
            evh_2186679009640457_clickPreventStop,
            save: act_4186377094414664_crud_4568,
            sendTestEmail: act_4699325371235600_request_4574,
            delete: act_1548630417156826_request_4578,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], MailAccountConfig.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MailAccountConfig.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], MailAccountConfig.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MailAccountConfig.prototype, "onSize", null);
MailAccountConfig = __decorate([
    (0, vue_property_decorator_1.Component)()
], MailAccountConfig);
exports.default = MailAccountConfig;
vue_property_decorator_1.Vue.component("MailAccountConfig", MailAccountConfig);
